<template>
  <div>
    <tool-bar title="Contact"></tool-bar>
    <div class="bg-F2F4F7 padding-v-15 padding-h-10">
      <div class="radius-15 bg-FFFFFF padding-h-20 margin-b-15 padding-v-18 " v-for="(i,index) of 2" :key="index">
        <div class="color-14171B font-18 font-bold flex-h flex-v-center">
          <img class="w-27 h-27 margin-r-10" src="../../assets/icon_contact.png" />
          <span>Emergency contact1</span>
        </div>
        <div class="flex-h flex-v-center bg-F7F9FC radius-8 padding-v-15 padding-h-10 flex-space-between">
          <div class="color-888F99 font-16">Relationship</div>
          <img class="w-6 h-7" src="../../assets/icon_triangle.png" />
        </div>
        <div class=" bg-F7F9FC radius-8 padding-v-15 padding-h-10   margin-t-10">
          <div class="flex-h flex-v-center flex-space-between">
            <div class="color-888F99 font-16">Name</div>
            <img  class="w-6 h-7" src="../../assets/icon_triangle.png" />
          </div>
          <div class="color-888F99 font-16 margin-t-15">Phone number</div>
        </div>
      </div>
      <div class="radius-15 bg-FFFFFF padding-h-20 margin-b-15 padding-v-18">
        <div>
          <img class="w-27 h-27" src="../../assets/icon_contact.png" />
          <span>Residential information</span>
        </div>
        <div class="flex-h flex-v-center flex-space-between bg-F7F9FC radius-8 padding-v-15 padding-h-10">
          <div class="color-888F99 font-16">Please select</div>
         <img  class="w-6 h-7" src="../../assets/icon_triangle.png" />
        </div>
        <div class=" margin-t-10">
          <textarea
          class="  bg-F7F9FC radius-8 color-888F99 font-16 padding-h-20 margin-b-15 padding-v-18"
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="Please fill in the detailed address"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>